import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { candidateBriefQueryKeys } from './queryKeys';
import type { CandidateBriefApi, CandidatePathParams } from './types';

export const candidateBriefQueryOptions = (params: CandidatePathParams) =>
  queryOptions({
    queryKey: candidateBriefQueryKeys.brief(params),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        '/jobs/{jobId}/candidates/{candidateId}/brief',
        { params: { path: params } },
      );

      return data as CandidateBriefApi;
    },
  });

export function useCandidateBriefQuery(params: CandidatePathParams) {
  return useQuery({
    ...candidateBriefQueryOptions(params),
    enabled: Boolean(params.jobId) && Boolean(params.candidateId),
  });
}
